import { render, staticRenderFns } from "./NamespaceOverview.vue?vue&type=template&id=5d443bd2&scoped=true"
import script from "./NamespaceOverview.vue?vue&type=script&lang=js"
export * from "./NamespaceOverview.vue?vue&type=script&lang=js"
import style0 from "./NamespaceOverview.vue?vue&type=style&index=0&id=5d443bd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d443bd2",
  null
  
)

export default component.exports